export default __webpack_public_path__ + "static/media/iit.5178a4b0.png";